export const POSSIBLE_TYPES = {
  PublicationDto: ["HhPublicationDto"],
  SourceDto: ["HhCandidateSourceDto", "HhApplicationSourceDto"],
  DocumentRegisterDto: [
    "SimpleDocumentRegisterDto",
    "CancellationDocumentRegisterDto",
  ],
  SigningDocumentDto: [
    "SimpleDocumentRegisterDto",
    "CancellationDocumentRegisterDto",
    "CrmDocumentDto",
    "SignRegistrationDto",
  ],
  DocumentRegisterSource: [
    "DocumentRegisterDocumentRegisterSource",
    "PersonAgreementDto",
    "JobOfferDto",
  ],
  SignerInfoDto: ["InternalSignerInfoDto", "ExternalSignerInfoDto"],
  SigningPermissions: ["DocumentRegisterPermissions", "CrmDocumentPermissions"],
  TaskDto: [
    "SimpleTaskDto",
    "SignDocumentTaskDto",
    "ConfirmCompanyDocumentReadTaskDto",
    "PassSurveyTaskDto",
    "CandidateInterviewTaskDto",
    "ApprovingRequestTaskDto",
    "NeedApproveDocumentRegisterTaskDto",
    "ApproveCrmDocumentTaskDto",
    "OpportunityActionTaskDto",
  ],
  ProjectDto: ["SimpleProjectDto", "OpportunityProjectDto"],
  CrmDocumentInterface: ["CrmDocumentDto", "OpportunityDocumentDto"],
  HierarchyElementDto: ["OrganizationDto", "PositionDto", "PersonDto"],
  AbstractRequestDto: [
    "AbsenceRequestDto",
    "BusinessTripRequestDto",
    "DynamicApprovingRequestDto",
    "ResignationRequestDto",
    "WeekendWorkRequestDto",
    "CompensatoryTimeOffRequestDto",
    "PositionChangeRequestDto",
    "SalaryChangeRequestDto",
    "PositionAndSalaryChangeRequestDto",
  ],
  WorkConditionsChangeRequestDto: [
    "PositionChangeRequestDto",
    "SalaryChangeRequestDto",
    "PositionAndSalaryChangeRequestDto",
  ],
  EmployeeEvent: [
    "BirthdayEmployeeEvent",
    "CompanyWorkAnniversaryEmployeeEvent",
    "ExternalCalendarEmployeeEvent",
    "RecurringExternalCalendarEmployeeEvent",
    "TaskDueEmployeeEvent",
    "RecurringTaskEmployeeEvent",
    "HolidayEmployeeEvent",
    "PersonAbsenceEmployeeEvent",
    "ProbationaryPeriodEndEmployeeEvent",
    "CandidateInterviewEmployeeEvent",
    "PersonBusinessTripEmployeeEvent",
    "CounterpartyBirthdayEmployeeEvent",
  ],
  TimedEmployeeEvent: ["ExternalCalendarEmployeeEvent", "TaskDueEmployeeEvent"],
  SeriesEmployeeEvent: [
    "RecurringExternalCalendarEmployeeEvent",
    "RecurringTaskEmployeeEvent",
  ],
  TaskEmployeeEvent: ["TaskDueEmployeeEvent", "RecurringTaskEmployeeEvent"],
  EmployeeEventOccurrence: [
    "ExternalCalendarEventOccurrence",
    "TaskEventOccurrence",
  ],
  TaskCompletion: ["OneTimeCompletionDto", "RecurringCompletionDto"],
  TaskChangeEvent: [
    "NameChangeEvent",
    "DescriptionChangeEvent",
    "PriorityChangeEvent",
    "DueDateChangeEvent",
    "PersonChangeEvent",
    "IsDoneChangeEvent",
    "ChangeAttachmentEvent",
  ],
  AbstractDynamicApprovingModelDefinitionDto: [
    "DynamicEntityBasedModelDefinitionDto",
    "DynamicModelDefinitionDto",
  ],
  DynamicAttributeMetaDto: [
    "EnumTypeDynamicAttributeDto",
    "ReferenceTypeDynamicAttributeDto",
    "SimpleTypeDynamicAttributeDto",
    "LocalizedValueDynamicAttributeDto",
  ],
  SimpleDynamicAttributeValueDto: [
    "StringDynamicAttributeValueDto",
    "BooleanDynamicAttributeValueDto",
    "DateDynamicAttributeValueDto",
    "DateTimeDynamicAttributeValueDto",
    "NumberDynamicAttributeValueDto",
    "FloatDynamicAttributeValueDto",
  ],
  ProcessRouteStepDto: ["RoleProcessRouteStepDto", "PersonProcessRouteStepDto"],
  SurveyParticipantAnswer: [
    "SurveyParticipantTextAnswerDto",
    "SurveyParticipantScaleAnswerDto",
  ],
  PersonCertificateDto: ["FilePersonCertificateDto", "UrlPersonCertificateDto"],
  SurveyScaleDto: ["QuestionContextSurveyScaleDto", "SimpleSurveyScaleDto"],
  AbstractSurveyQuestion: [
    "ScaleQuestionDto",
    "TextQuestionDto",
    "AssessmentScaleQuestionDto",
    "TestScaleQuestionDto",
  ],
  CounterpartyDto: ["LegalCounterpartyDto", "PhysicalCounterpartyDto"],
  DayResult: ["DictionaryDayResult", "SpecialDayResult"],
  SignerDto: ["ExternalSignerDto", "InternalSignerDto"],
  CrmDocumentSignerDto: [
    "CrmDocumentEmployeeSignerDto",
    "CrmDocumentExternalSignerDto",
  ],
  TeamAbsenceEventDto: [
    "TeamAbsenceEventBusinessTripDto",
    "TeamAbsenceEventAbsenceDto",
  ],
  SurveyParticipantDto: [
    "RegularSurveyParticipantDto",
    "AssessmentSurveyParticipantDto",
    "TestSurveyParticipantDto",
  ],
  CompanyDocumentTreeNodeDto: [
    "CompanyDocumentFileNodeDto",
    "CompanyDocumentFolderNodeDto",
  ],
  BaseSurveyDto: ["AssessmentSurveyDto", "SurveyDto", "TestSurveyDto"],
  TestSurveySourceDto: ["CompanyDocumentTestSurveySourceDto"],
  AiChatMessage: [
    "ChangeStageAiChatMessage",
    "UpdateMessageAiChatMessage",
    "ToolCallAiChatMessage",
  ],
  Repetition: ["EveryYear", "Once"],
  AssetHistoryEventDto: ["AssetIssueEventDto", "AssetReturnEventDto"],
  DocumentRegisterTypeOriginDto: [
    "ManualOriginDto",
    "AbsenceOriginDto",
    "ResignationOriginDto",
    "BusinessTripOriginDto",
    "WeekendWorkOriginDto",
    "CompensatoryTimeOffOriginDto",
    "DynamicModelOriginDto",
    "AgreementOriginDto",
    "PositionChangeOriginDto",
    "SalaryChangeOriginDto",
    "PositionAndSalaryChangeOriginDto",
    "JobOfferOriginDto",
  ],
  DocumentRegisterTypePermissions: [
    "CommonDocumentRegisterTypePermissions",
    "AbsenceDocumentRegisterTypePermissions",
  ],
  CurrentUserProtectionTokenDto: [
    "AccessProtectionTokenDto",
    "EnabledProtectionTokenDto",
    "ContextProtectionTokenDto",
  ],
  ActualProtectionTokenDto: [
    "ActualAccessProtectionTokenDto",
    "ActualEnabledProtectionTokenDto",
  ],
  EditableProtectionTokenNodeDto: [
    "EditableAccessProtectionTokenNodeDto",
    "EditableEnabledProtectionTokenNodeDto",
    "EditableIntermediateProtectionTokenNodeDto",
  ],
  TriggerActionSettings: [
    "CreateTaskAction",
    "SendNotificationAction",
    "AssignSurveyAction",
    "UnknownTriggerAction",
  ],
  BusinessTriggerEventFilterSettings: [
    "ApproveApprovingRequestFilterSettings",
    "DocumentRegisterSignedFilterSettings",
  ],
  PersonRefDto: ["ExpressionRefDto", "EntityIdRefDto"],
  DicTaskPriorityRefDto: ["ExpressionRefDto", "EntityIdRefDto"],
  SurveyRefDto: ["ExpressionRefDto", "EntityIdRefDto"],
  OffsetDateTimeRefDto: ["ExpressionRefDto", "OffsetDateTimeValueRefDto"],
};
